import type { DatabricksCatalogSettings } from '@protoss/shared';
import * as React from 'react';
import { dataCatalogApi } from '../services/dataCatalogApi';

export function useDataCatalogSettings(projectUuid: string) {
  const [settings, setSettings] = React.useState<DatabricksCatalogSettings | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  const load = React.useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { settings: data } = await dataCatalogApi.getSettings(projectUuid);
      setSettings(data);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }, [projectUuid]);

  React.useEffect(() => {
    void load();
  }, [load]);

  return { settings, loading, error, reload: load };
}
